const carList = () => {

  const carListCards = document.querySelectorAll('.car-lists__card')

  return {
    toggleCarCards: () => {
      carListCards.forEach(elem => {
        elem.addEventListener('mouseenter', () => {
          if (!elem.classList.contains('open')) {
            elem.classList.add('open')
          }
        })
        elem.addEventListener('mouseleave', () => {
          if (elem.classList.contains('open')) {
            elem.classList.remove('open')
          }
        })
      })
    },
    setCardSize: () => {
      carListCards.forEach(elem => {
        const elemHeight = elem.clientHeight
        elem.parentElement.style.maxHeight = `${elemHeight}px`
      })
    }
  }
}
export default carList
